import React, { FC, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Button, { ButtonProps } from '@mui/material/Button';
// Components
import { ArrowBack } from '@mui/icons-material';
import Space from '../layout/space';
// Resources
import { paths } from '../../navigation/routes/paths';

interface BackButtonBaseProps extends ButtonProps {
    onClickAction?: () => void;
}

const BackButtonBase: FC<BackButtonBaseProps> = (props): ReactElement => {
    const { onClickAction } = props;

    const classes = useStyles();
    const navigate = useNavigate();

    const onAction = (): void => {
        navigate(paths.home);
    };

    return (
        <>
            <Button
                id="backButton"
                onClick={onClickAction ?? onAction}
                startIcon={<ArrowBack className={classes.icon} />}
                className={classes.backButtonRoot}
            />
            <Space value={1} />
        </>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButtonRoot: {
            height: '30px',
            borderRadius: '20px',
            display: 'flex',
            justifyContent: 'flex-start',
            padding: 0,
            width: 'inherit',
            color: theme.palette.primary.main,
            '&:hover': {
                background: 'unset',
            },
            minWidth: '40px!important',
        },
        icon: {
            color: theme.palette.colors.icon.primary,
        },
    }),
);

export default BackButtonBase;
